import React from 'react';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { useParams } from 'react-router-dom';
import { PermissionTypesEnum } from '@api/ringil-api.v2.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';
import Visit from '@app/pages/timeslots/visit/Visit.tsx';

interface ComponentProps {
}

const VisitDetailPage: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();

  const { visitId } = useParams();


  return (
    <>
      <ResponsiveLayout title={tr(`VisitDetailPage.title`, `Visit detail`)}
                        oneOfPermission={[PermissionTypesEnum.PERMISSION_TIMESLOT_VISITORS_READ, PermissionTypesEnum.PERMISSION_TIMESLOT_VISITORS_WRITE]}>
        <Visit visitId={visitId} />
      </ResponsiveLayout>
    </>
  );
};

export default withAuthenticationRequired(VisitDetailPage);
